module.exports = __webpack_public_path__ + "img/Norms and Empires Lecture Series.7af7e6a1.png";